const DOMAIN_TO_WORKER = {
    'www.ibroxnews.com':                  'https://ibroxnews.quintype.workers.dev',
    'www.footballinsider247.com':          'https://football-insider.quintype.workers.dev',
    'footballinsider247-madrid.qtstage.io':'https://football-insider-stg.quintype.workers.dev',
    'www.theportsmouthnews.com':           'https://theportsmouthnews.quintype.workers.dev',
    'www.mackemnews.com':                  'https://mackem-news.quintype.workers.dev',
    'www.liverpoolnews247.com':            'https://liverpoolnews247.quintype.workers.dev',
    'www.astonvillanews.co.uk':            'https://astonvillanews.quintype.workers.dev',
    'www.tottenhamhotspurnews.com':        'https://tottenhamhotspurnews.quintype.workers.dev',
    'www.westbromnews.co.uk':              'https://westbromnews.quintype.workers.dev',
    'motleedsnews.com':                    'https://motleedsnews.quintype.workers.dev',
    'www.westhamzone.com':                 'https://westhamzone.quintype.workers.dev',
    'www.goodisonnews.com':                'https://goodisonnews.quintype.workers.dev',
};

const safeEnv = (key, fallback = '') => {
    try {
        if (typeof process !== 'undefined' && process.env && process.env[key]) {
            return process.env[key];
        }
    } catch (e) {}
    return fallback;
};

export function getApiHost() {
    if (typeof window !== 'undefined') {
        return DOMAIN_TO_WORKER[window.location.hostname] || safeEnv('NEXT_PUBLIC_API_HOST') || '';
    }
    return safeEnv('API_HOST') || '';
}
